<template>
  <div class="render-sort" v-bind="$attrs" @click="sort()">
    <b-icon
      v-if="currentColumnFiltered !== columnKey"
      icon="arrow-up-short"
      scale="1.5"
      variant="dark"
    />
    <b-icon
      v-else-if="currentColumnFiltered === columnKey && sortDirection === 'ASC'"
      icon="arrow-up-short"
      scale="1.5"
      variant="success"
    />
    <b-icon v-else icon="arrow-down-short" scale="1.5" variant="success" />
    <!-- {{ columnName }} -->
  </div>
</template>

<script>
export default {
  props: {
    columnKey: {
      type: String,
      default: '',
      required: true,
    },
    columnName: {
      type: String,
      default: '',
      required: true,
    },
    currentColumnFiltered: {
      type: String,
      default: '',
      required: true,
    },
    sortDirection: {
      type: String,
      default: 'ASC',
      required: true,
    },
  },
  methods: {
    sort() {
      this.$emit('sortListByKey');
    },
  },
};
</script>

<style lang="scss" scoped>
.render-sort {
  cursor: pointer;
}
</style>
